// The white-screen catcher.
//
// A render-time throw anywhere in the tree unmounts the whole app and leaves a
// blank page — no message, no way back, and (before this) no report either.
// The boundary turns that into a screen that says what happened and offers the
// one action that reliably works, while Sentry gets the stack.
//
// Deliberately styled with plain inline rules rather than the app's classes:
// this renders precisely when something is broken, and a stylesheet that
// failed to load is one of the things that can break it.
export default function CrashScreen({ error, resetError }) {
  return (
    <div style={{
      minHeight: '100dvh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '1rem',
      padding: '2rem', textAlign: 'center',
      font: '16px/1.5 system-ui, -apple-system, sans-serif',
      background: '#11100f', color: '#f2eee7',
    }}>
      <h1 style={{ font: '600 1.25rem/1.3 inherit', margin: 0 }}>
        Something broke on this screen
      </h1>
      <p style={{ margin: 0, maxWidth: '32ch', opacity: 0.75 }}>
        Nothing you were working on has been lost. We've been told about it.
      </p>
      <button
        onClick={resetError}
        style={{
          marginTop: '0.5rem', padding: '0.7rem 1.4rem', borderRadius: '999px',
          border: 0, font: '600 1rem/1 inherit', cursor: 'pointer',
          background: '#f2eee7', color: '#11100f',
        }}
      >
        Try again
      </button>
      <button
        onClick={() => { window.location.href = '/' }}
        style={{
          padding: '0.5rem 1rem', borderRadius: '999px', cursor: 'pointer',
          border: '1px solid rgba(242,238,231,0.25)', font: '500 0.9rem/1 inherit',
          background: 'transparent', color: 'inherit',
        }}
      >
        Back to start
      </button>
      {import.meta.env.DEV && (
        <pre style={{
          marginTop: '1.5rem', maxWidth: '90vw', overflow: 'auto',
          textAlign: 'left', font: '12px/1.4 ui-monospace, monospace',
          opacity: 0.6,
        }}>{String(error?.stack || error)}</pre>
      )}
    </div>
  )
}
